/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { TransportMiddlewareProps, HttpResponseCodes, isErrorThatNeedToBeShown } from '../../../../core';

import type { TransportMiddlewareContext, TransportMiddlewareRequest, TransportMiddlewareResponse, NextFunction } from '../../../../core';

export const handleHttpResponseMiddleware = <T, R, E>(
    next: NextFunction<TransportMiddlewareResponse<R, E> | Error>,
    ctx: TransportMiddlewareContext,
    req: TransportMiddlewareRequest<T>,
    res: TransportMiddlewareResponse<R, E>
) => {
    const { response } = res;

    if (!response.ok) {
        next(res);
    } else if (response.status === HttpResponseCodes.Accepted || response.status === HttpResponseCodes.NoContent) {
        res[TransportMiddlewareProps.ResponseProp] = {} as R;
        next();
    } else {
        response.json()
            .then((data: R) => {
                res[TransportMiddlewareProps.ResponseProp] = data;
                next();
            })
            .catch((err: Error) => {
                isErrorThatNeedToBeShown(err) && console.error(err);
                res[TransportMiddlewareProps.ErrorResponse] = err;
                next(res);
            });
    }
};
